import React, { createContext, useState, useEffect, useRef, useContext } from 'react';

const AllContext = createContext();

const AllProvider = ({ children }) => {
  const [admLogeado, setAdmLogeado] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [ IsT , setIsT] = useState()

  return (
    <AllContext.Provider value={{ IsT, setIsT, admLogeado, setAdmLogeado, userEmail, setUserEmail }}>
      {children}
    </AllContext.Provider>
  );
};

export { AllContext, AllProvider };